import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudWeather: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloud-weather, clouds"><path d="M8.925 4C4.54081 4 1 7.58909 1 12C1 16.4109 4.54081 20 8.925 20H17.125C20.377 20 23 17.3383 23 14.0714C23 10.8045 20.377 8.14286 17.125 8.14286C16.7177 8.14286 16.3195 8.1848 15.9347 8.26476C14.6075 5.73199 11.9695 4 8.925 4Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCloudWeather;
